import { getStorage } from '../shared/storage'

let lastLoginHostname
;(async () => {
  lastLoginHostname = await getStorage('lastLoginHostname')
})()

export function getLastLoginHostname() {
  if (lastLoginHostname?.lastLoginHostname) {
    return lastLoginHostname.lastLoginHostname
  } else {
    return ''
  }
}
